// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7229152b","453":"73290240","796":"99e883d6"}[chunkId] + ".chunk.js";
};